// extracted by mini-css-extract-plugin
export default {"sponsorsGrid":"Sponsors_sponsorsGrid__1T9+x","sponsorLogo":"Sponsors_sponsorLogo__F7eV5"};